export const ADDRESS_DELETE_RESET = 'ADDRESS_DELETE_RESET'
export const ADDRESS_DELETE_SET_ERROR = 'ADDRESS_DELETE_SET_ERROR'
export const ADDRESS_DELETE_SET_DELETED = 'ADDRESS_DELETE_SET_DELETED'
export const ADDRESS_DELETE_TOGGLE_LOADING = 'ADDRESS_DELETE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/address/delete/mutation_types.js